<template>
  <div class="mx-4 my-2">

    <vue-headful :title="title" />
    <div class="card">
        <div class="card-header">
          <div class="card-header-title">JSON</div>
          <button class="card-header-icon" aria-label="more options">
            <span class="icon" @click="jsonToggledOn = !jsonToggledOn">
              <font-awesome-icon :icon="['far', 'angle-down']" v-if="jsonToggledOn" />
              <font-awesome-icon :icon="['far', 'angle-up']" v-if="!jsonToggledOn" />
            </span>
          </button>
        </div>
        <div v-if="subscription && jsonToggledOn" class="card-content p-0">
          <pre v-html="prettyPrintJson.toHtml(subscription, { indent: 2 })"></pre>
        </div>
      </div>
  </div>
</template>
<script setup>
import { computed, ref } from 'vue';
import { prettyPrintJson } from 'pretty-print-json';
import { useSubscriptions2Store } from '../subscriptions2-store';

const jsonToggledOn = ref(true);
const store = useSubscriptions2Store();

const subscription = computed(() => store.state.subscription);
const title = computed(() => `${subscription.value?.description} / JSON`);
</script>
